<template>
  <div class="admin-page">
    <h2 class="page-title">私信举报</h2>
    <div class="admin-toolbar">
      <el-select v-model="status" @change="load">
        <el-option label="待处理" :value="0" />
        <el-option label="已处理" :value="1" />
        <el-option label="已驳回" :value="2" />
      </el-select>
      <el-button type="primary" @click="load">刷新</el-button>
    </div>
    <el-table :data="rows" v-loading="loading" border>
      <el-table-column prop="reporter" label="举报人" width="120" />
      <el-table-column prop="content" label="消息" min-width="220" show-overflow-tooltip />
      <el-table-column prop="reason" label="原因" min-width="160" show-overflow-tooltip />
      <el-table-column label="操作" width="180" v-if="status === 0">
        <template #default="s">
          <el-button link type="primary" @click="handle(s.row, 1)">处理</el-button>
          <el-button link type="danger" @click="handle(s.row, 2)">驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
    <p v-if="!loading && rows.length === 0" class="empty">没有记录</p>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import { authHeaders } from '@/utils/http'

export default {
  name: 'AdminChatReports',
  setup() {
    const loading = ref(false)
    const status = ref(0)
    const rows = ref([])
    const load = async () => {
      loading.value = true
      try {
        const res = await axios.post('/api/v1/admin/friend/chat/reports', { status: status.value, page: 1, pageSize: 50 }, { headers: authHeaders() })
        if (res.data.code === 200) rows.value = res.data.data?.reports || []
        else ElMessage.error(res.data.message || '读取失败')
      } catch (e) {
        ElMessage.error('读取失败')
      } finally {
        loading.value = false
      }
    }
    const handle = async (row, next) => {
      try {
        const { value } = await ElMessageBox.prompt(next === 1 ? '处理说明，会发给举报人' : '驳回说明，会发给举报人', next === 1 ? '处理举报' : '驳回举报', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '可留空'
        })
        const res = await axios.post('/api/v1/admin/friend/chat/reports/handle', { id: row.id, status: next, note: (value || '').trim() }, { headers: authHeaders() })
        if (res.data.code === 200) {
          ElMessage.success('已保存')
          load()
        } else ElMessage.error(res.data.message || '保存失败')
      } catch (e) {
        if (e !== 'cancel') ElMessage.error('保存失败')
      }
    }
    onMounted(load)
    return { loading, status, rows, load, handle }
  }
}
</script>

<style scoped>
.empty { color: var(--el-text-color-secondary); padding: 16px 0; }
</style>
